import { createContext } from 'react'
import type { Platform, RegistryData, Skill, Tool, Workflow } from '../types'

export interface ForgeState {
  selectedSkills: string[]
  selectedWorkflow: string | null
  platform: Platform
  tool: Tool
  registry: RegistryData | null
  loading: boolean
  toggleSkill: (id: string) => void
  selectWorkflow: (id: string | null) => void
  setPlatform: (p: Platform) => void
  setTool: (t: Tool) => void
  clearSelection: () => void
  command: string
  selectedSkillObjects: Skill[]
  selectedWorkflowObject: Workflow | null
}

export const ForgeContext = createContext<ForgeState | null>(null)
